<template>
  <div class="m-4 p-4">
    <div >
      <!-- isReady: {{isReady}} || {{goalId}} -->
      <template v-if="isReady">
        <div class="row">
          <div class="col-lg-4">
            <div class="card">
              <div class="card-body">
                <h1>{{publicGoalData.name}}</h1>
                (Cached: {{goalMetaData.cachedName}})

                <img :src="image_source" />
                <font-awesome-icon icon="wrench" class="taskicon" @click.prevent="onEdit" />
                <font-awesome-icon icon="trash-alt" class="taskicon" @click.prevent="onRemove" />
              </div>
            </div>
            <div class="card mt-4">
              <div class="card-body">
                <!-- <GoalHeader :goal-id="goalId" :goal="publicGoalData" /> -->
                <h6 class="mt-4">Members:</h6>
                <ul>
                  <!-- TODO: copy table from modal -->
                  <li v-for="(member, memberId) in publicGoalData.members" :key="memberId">
                    <span style="font-size: 10pt">{{member.cachedName}}</span>
                  </li>
                </ul>
                <!--
                <div
                  class="lane"
                  v-for="(invitation, invitation_idx) in goal_invite_list"
                  :key="'invitation'+invitation_idx">
                  <div class="list invite-list">
                    <header> {{invitation.cachedGoalName}} </header>
                    <ul>
                      <li>
                        You got an invitation to <strong>{{invitation.cachedGoalName}}</strong>
                        from <strong>{{invitation.cachedSenderName}}.</strong><br /><br />
                        <span>{{invitation.invitedAt|calendarDateFromFirebase}}</span>
                      </li>
                    </ul>
                    <footer>
                      <el-button @click="onAcceptInvitation(invitation.id, invitation.cachedGoalName, true)">Accept</el-button>
                      <el-button @click="onAcceptInvitation(invitation.id, invitation.cachedGoalName, false)" variant="danger">Decline</el-button>
                    </footer>
                  </div>
                </div>
                -->
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                Chat / Activities
              </div>
              <div class="card-body p-1">
                <div class="activities">
                  <Activities :goal_id="goalId" />
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                Stats / Challenge
              </div>
              <div class="card-body">
                <pre class="m-2">challengeId: {{publicGoalData.challengeId}}</pre>
                <pre class="m-2">goalStatistics: {{publicGoalData.goalStatistics}}</pre>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <el-card class="box-card mb-5" :body-style="{ padding: '0px' }">
              <div slot="header" class="clearfix">
                <span>Efforts
                <el-input
                  v-model="searchEfforts"
                  size="mini"
                  placeholder="Type to search effort"/>
                </span>
                <template>
                  <el-table
                    :data="effortsTableData"
                    style="width: 100%"
                    stripe
                    highlight-current-row
                    ref="effortsTable"
                    @current-change="handleCurrentChange">
                    <el-table-column
                      fixed
                      type="expand">
                      <template slot-scope="props">
                        <template >
                          Progress: <el-progress :text-inside="true" :stroke-width="18" :percentage="70"></el-progress>
                          <p>Start Date: {{ props.row.startDate }}</p>
                          <p>Deadline: {{ props.row.endDate }}</p>
                          <p>Due Date: {{ props.row.endDate }}</p>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column
                      sortable
                      label="Name"
                      prop="name"
                      style="min-width: 70%">
                    </el-table-column>
                    <el-table-column
                      sortable
                      label="Status"
                      prop="status">
                      <template slot-scope="scope">
                        <span :class="scope.row.status">{{ scope.row.status }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      sortable
                      label="Due Date"
                      prop="endDate">
                    </el-table-column>
                    <el-table-column
                      sortable
                      label="Progress"
                      width="180">
                      <template slot-scope="scope">
                        <el-progress :text-inside="true" :stroke-width="18" :percentage="70"></el-progress>
                        <span style="margin-left: 10px">{{ scope.row.progress }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column
                      sortable
                      label="Health"
                      prop="">
                    </el-table-column>

                  </el-table>
                </template>
                <!-- TODO: Implement simple card seach function -->
              </div>
            </el-card>
            <el-card class="box-card mb-5" :body-style="{ padding: '0px' }">
              <div slot="header" class="clearfix">
                <span>Tasks</span>
                <router-link :to="'/kanban/'+goalId">
                  <el-button plain size="small" icon="el-icon-check" style="float: right">Go to Kanban-Board</el-button>
                  <!-- {{name of kanban}} -->
                </router-link>
                <!-- TODO: Implement simple card seach function -->
              </div>
              <div>
                <div class="list" style="overflow-y: scroll; height: 300px">
                  <task-list
                    :goal_id="goalId"
                    :tasklist="goal_tasklist_filtered"
                    />
                </div>
              </div>
            </el-card>
            <div class="card">
              <div class="card-header">
                Efforts
              </div>
              <div class="card-body">
                <!-- TODO: Drag and drop order -> see modal -->
                <div
                  class="dropdown-item"
                  v-for="(effort, commitmentId) in effortList"
                  :key="'E-'+commitmentId">
                  <InlineCommitment :commitment="effort" />
                  <template v-if="effort.type === 'SEQUENCE_TYPE2'">
                    <InlineSequence
                      class="mt-2 mb-2"
                      style="border: 2px solid #dcdfe6;"
                      :sequence-effort="effort" />
                  </template>
                  <!-- <div v-if="effort.timeslotCollectionId">
                    Assigned to
                    <InlineTimeslotCollection :tsc_id="effort.timeslotCollectionId" />
                    <a href="#" @click.prevent="jumpTo('Timeslots', effort.timeslotCollectionId)">{{tscList.find(tsc => tsc.$id === effort.timeslotCollectionId).name}}</a>
                  </div>
                  <div v-else>
                    Not assigned
                  </div>
                  -->
                </div>
                <el-button @click="onAddCommitment" size="mini">add effort</el-button>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                Goal Data (TBD)
              </div>
              <pre class="card-body">
Description: {{publicGoalData.description}}
Rules: {{publicGoalData.rules}}
userPictureOverride: {{goalMetaData.userPictureOverride}}
              </pre>
            </div>
            <div class="card">
              <div class="card-header">
                Meta Data (TBD)
              </div>
              <pre class="card-body">
userLeftGroup: {{goalMetaData.userLeftGroup}}
Visibility: {{publicGoalData.visibility}}
IsTeamgoal: {{publicGoalData.isTeamgoal}}
Deleted: {{publicGoalData.deleted}}
              </pre>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        Loading...
      </template>
    </div>
  </div>
  <!--
  TODO:
  X Show chat
  X Show details
  - Show invite
  - Goal config Modal
  X Picture / User picture
  - ...
  -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Activities from '@/components/GoalPage/Elements/Activities'
import InlineCommitment from '@/components/Inline/InlineCommitment'
// import GoalHeader from '@/components/GoalPage/Elements/Header'
import TaskList from '@/components/GoalPage/Elements/TaskList'
import InlineSequence from '@/components/Inline/InlineSequence'
import moment from '@/moment-gp'

// TODO: Move shared code with inline goal to mixin
// TODO: Move content to Component GoalDeails.vue

export default {
  name: "GoalPage",
  data: () => ({
    goalId: null,
    searchEfforts: ''
  }),
  created() {
    this.setCurrentGoal();
  },
  watch: {
    $route (to, from) {
      if ( to.name === 'goal' ) {
        this.setCurrentGoal();
      }
    }
  },
  computed: {
    ...mapGetters("goal", [
      "unsorted_tasks",
      "goal_by_id",
      "goal_list_meta_ready_with_deleted",
      "goal_list_state",
      "goal_is_ready",
      "effort_list_by_goal_id"
    ]),
    ...mapGetters("user", [
      "userData",
    ]),

    isReady() {
      return this.goal_is_ready( this.goalId );
    },

    publicGoalData() {
      return this.goal_by_id( this.goalId );
    },

    effortList() {
      return this.effort_list_by_goal_id( this.goalId );
    },

    goalMetaData() {
      let goal = this.goal_list_state[ this.goalId ] || {};
      return goal.meta || null;
    },

    image_source() {
      let publicGoal = this.publicGoalData;
      return publicGoal ? publicGoal.picture : '';
    },

    goal_tasklist_filtered() {
      return this.unsorted_tasks( this.goalId );
    },

    /* THIS NEEDS REWRITING !!! */
    /*
    goal_list_meta_selected() {
      if ( this.$route && this.$route.params.goalId ) {
        let goal_meta = Object.assign({},
          this.goal_list_state[ this.$route.params.goalId ].meta,
          {
            id: this.$route.params.goalId,
          });
        return [ goal_meta ];
      } else {
        return this.goal_list_meta_ready_with_deleted;
      }
    },
    */

    /* TODO: Maybe even move this to topbar / notifications */
    goal_invite_list() {
      let user = this.userData;
      if (user && 'goalInviteList' in user) {
        return Object.keys(user.goalInviteList).map(key => {
          return { ...user.goalInviteList[key], id: key };
        });
      } else {
        return [];
      }
    },

    effortsTableData() {
      console.log('effortList',this.effortList)
      let effortsTableData = this.effortList.filter(
        data => !data.deleted &&
        (
          (!this.searchEfforts === '')
          || data.name.toLowerCase().includes(this.searchEfforts.toLowerCase())
        )
      ).map(item => {
        let startDate = item.startDate ? item.startDate.format(this.$models.userSettings.getters.user_get_dateformat) : ' none '
        let endDate = item.endDate ? item.endDate.format(this.$models.userSettings.getters.user_get_dateformat) : 'none'
        let remainingTime = item.dataFields && item.dataFields.remainingTime ? item.dataFields.remainingTime : 0
        let totalMinutes = item.dataFields && item.dataFields.totalMinutes ? item.dataFields.totalMinutes : 0

        let status = 'unchanged'
        let progress = ''
        let percentage = ''
        if (totalMinutes > 0) {
          percentage = 100 - remainingTime / 60 / totalMinutes * 100;
          progress = (remainingTime / 3600 ).toFixed(1)  + ' of ' + (totalMinutes / 60 ).toFixed(1) + "h" + ' ( ' + percentage + '% )'
        } else {
          progress = (remainingTime / 3600 ).toFixed(1)  + ' of ' + (totalMinutes / 60 ).toFixed(1) + "h"
        }

        if (moment.currentDate() < item.startDate) {
          status = 'pending'
        } else if (moment.currentDate() > item.endDate) {
          if (remainingTime === 0) {
            status = 'completed'
          } else {
            status = 'overdue'
          }
        } else if ((!item.startDate || moment.currentDate() >= item.startDate) && (!item.endDate || moment.currentDate() <= item.endDate) ) {
          status = 'active'
        }

        return {
        name: item.name,
        startDate: startDate,
        endDate: endDate,
        percentComplete: 0,
        remainingHours: (remainingTime / 3600 ).toFixed(1) + "h",
        status: status,
        progress: progress
        }
      })
      console.log('effortsTableData', effortsTableData)
      return effortsTableData
    }
  },
  methods: {
    ...mapActions("goal", [
      "create_goal",
      "accept_invitation",
    ]),

    setCurrentGoal() {
      this.goalId = this.$route.params.goalId;
    },

    /*
    onAcceptInvitation(invitation_id, invitation_name, accept) {
      this.accept_invitation({
        goal_id: invitation_id,
        goal_name: invitation_name,
        accept: accept
      })
    },

    onAddGoal() {
      this.create_goal({
          title: this.new_lane_title,
          type: this.selected_goal_type
      });
    },
    */

    onRemove() {
      console.log("todo");
    },

    onEdit() {
      this.$root.showUpdateModal('goal', {
        goalId: this.goalId
      });
    },

    onAddCommitment() {
      this.$root.showNewModal('effort', { goalId: this.goalId });
    },

    handleCurrentChange(val) {
        console.log('handleCurrentChange()', val)
        this.$refs.effortsTable.toggleRowSelection(val);
        this.effortsTableData.forEach(row => {
          this.$refs.effortsTable.toggleRowExpansion(row, false);
        });
        this.$refs.effortsTable.toggleRowExpansion(val, true);
    }
  },
  components: {
    Activities,
    InlineCommitment,
    // GoalHeader,
    TaskList,
    InlineSequence
  }
};
</script>
<style>
.pending {
  color: #f9ae00
}
.active {
  color: #009f3c
}
.overdue {
  color: #e30613
}
.completed {
  color: #009f3c
}
.paused {
  color: #e74310
}
  </style>
